import { c as _c } from "react/compiler-runtime";
import { chooseSplitTestVariant } from 'modules/funnels/funnel/api/funnel-api';
import { useBTestFunnelSteps } from 'modules/funnels/funnel/hooks/use-b-test-funnel-step';
import { useFunnelStepTests } from 'modules/funnels/funnel/hooks/use-funnel-step-tests';
import { useFunnelStepsList } from 'modules/funnels/funnel/hooks/use-funnel-steps-list';
import { useGoalTestFunnelSteps } from 'modules/funnels/funnel/hooks/use-goal-test-funnel-step';
import { FunnelStepInterface } from 'modules/funnels/funnel/types/funnel-step-interface';
import { ChooseSplitTestVariantErrorsInterface, ChooseSplitTestVariantInterface } from 'modules/funnels/funnel/types/funnel-tests-interface';
import { getAllowedStepsAsGoal, getAllowedStepsAsVariant } from 'modules/funnels/funnel/utils/split-tests-utils';
import { FunnelId } from 'modules/funnels/types/funnel-interface';
import React, { useState } from 'react';
import { Button, FormSelect } from 'shared/components';
import CreateModal from 'shared/components/create-modal';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { fetchWithFieldErrors } from 'shared/utils/fetch-with-errors';
const defaultValues: ChooseSplitTestVariantInterface = {
  goalFunnelStep: undefined,
  funnelStepB: undefined
};
const defaultErrors: ChooseSplitTestVariantErrorsInterface = {
  fields: {
    goalFunnelStep: '',
    funnelStepB: ''
  }
};
interface ChooseTestVariantModalProps {
  funnelId: FunnelId;
  funnelStep: FunnelStepInterface;
}
function ChooseTestVariantModal(t0) {
  const $ = _c(35);
  const {
    funnelId,
    funnelStep
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const [opened, setOpened] = useState(false);
  const [errors, setErrors] = useState(defaultErrors);
  const {
    mutateFunnelStepsList
  } = useFunnelStepsList(funnelId);
  const {
    mutateSplitTest
  } = useFunnelStepTests(funnelStep.id);
  const [shouldFetchFieldsData, setShouldFetchFieldsData] = useState(false);
  const {
    bFunnelStepsData
  } = useBTestFunnelSteps(funnelStep?.id, shouldFetchFieldsData);
  const {
    goalFunnelStepsData
  } = useGoalTestFunnelSteps(funnelStep?.id, shouldFetchFieldsData);
  let t1;
  if ($[0] !== funnelStep || $[1] !== mutateFunnelStepsList || $[2] !== mutateSplitTest) {
    t1 = async data => {
      await fetchWithFieldErrors(async () => {
        if (funnelStep) {
          const response = await chooseSplitTestVariant(funnelStep.id, data);
          await mutateSplitTest(response.data, false);
          await mutateFunnelStepsList(data_0 => {
            if (data_0) {
              return data_0.map(funnelStep_0 => {
                const isFunnelStepAOrB = funnelStep_0.id === response.data.funnelStepA.id || funnelStep_0.id === response.data.funnelStepB.id;
                const isGoalFunnelStep = funnelStep_0.id === response.data.goalFunnelStep.id;
                const currentSplitTest = isFunnelStepAOrB ? {
                  id: response.data.id,
                  funnelStepA: {
                    id: response.data.funnelStepA.id,
                    page: response.data.funnelStepA.page
                  },
                  funnelStepB: {
                    id: response.data.funnelStepB.id,
                    page: response.data.funnelStepB.page
                  }
                } : funnelStep_0.currentSplitTest;
                if (funnelStep_0.id === response.data.funnelStepA.id || funnelStep_0.id === response.data.funnelStepB.id) {
                  return {
                    ...funnelStep_0,
                    currentSplitTest: {
                      id: response.data.id,
                      funnelStepA: {
                        id: response.data.funnelStepA.id,
                        page: response.data.funnelStepA.page
                      },
                      funnelStepB: {
                        id: response.data.funnelStepB.id,
                        page: response.data.funnelStepB.page
                      }
                    }
                  };
                }
                return {
                  ...funnelStep_0,
                  currentSplitTest,
                  goalFunnelStepOfAnySplitTest: isGoalFunnelStep || funnelStep_0.goalFunnelStepOfAnySplitTest
                };
              });
            }
          }, false);
        }
      }, setErrors);
    };
    $[0] = funnelStep;
    $[1] = mutateFunnelStepsList;
    $[2] = mutateSplitTest;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const onCreate = t1;
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = e => {
      e.preventDefault();
      setOpened(true);
      setShouldFetchFieldsData(true);
    };
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t) {
    t3 = t("dashboard.funnel.split_tests.choose_variant");
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t3) {
    t4 = <Button onClick={t2}>{t3}</Button>;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t) {
    t5 = t("global.save");
    $[9] = t;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t) {
    t6 = t("dashboard.funnel.split_tests.choose_variant_modal_title");
    $[11] = t;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = () => setOpened(false);
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== bFunnelStepsData || $[15] !== errors || $[16] !== t) {
    t8 = {
      field: "funnelStepB",
      onRender: (value, onChange) => <div key="funnel-step-b" className="min-w-0"><FormSelect data={getAllowedStepsAsVariant(bFunnelStepsData)} label={t("dashboard.funnel.split_tests.variant_funnel_step")} value={value} onChange={value_0 => onChange(value_0)} placeholder={t("dashboard.funnel.split_tests.choose_page")} required={true} withoutCloseIcon={true} error={errors.fields.funnelStepB} /></div>
    };
    $[14] = bFunnelStepsData;
    $[15] = errors;
    $[16] = t;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== errors || $[19] !== goalFunnelStepsData || $[20] !== t) {
    t9 = {
      field: "goalFunnelStep",
      onRender: (value_1, onChange_0) => <div key="funnel-step-goal-page" className="min-w-0"><FormSelect data={getAllowedStepsAsGoal(goalFunnelStepsData)} label={t("dashboard.funnel.split_tests.goal_funnel_step")} value={value_1} onChange={value_2 => onChange_0(value_2)} placeholder={t("dashboard.funnel.split_tests.choose_page")} required={true} withoutCloseIcon={true} error={errors.fields.goalFunnelStep} /></div>
    };
    $[18] = errors;
    $[19] = goalFunnelStepsData;
    $[20] = t;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== t8 || $[23] !== t9) {
    t10 = [t8, t9];
    $[22] = t8;
    $[23] = t9;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = ["funnelStepB", "goalFunnelStep"];
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== onCreate || $[27] !== opened || $[28] !== t10 || $[29] !== t5 || $[30] !== t6) {
    t12 = <CreateModal buttonCaption={t5} fullCaption={t6} opened={opened} onClose={t7} defaultValues={defaultValues} needToast={false} creatable={t10} onCreate={onCreate} requiredFields={t11} />;
    $[26] = onCreate;
    $[27] = opened;
    $[28] = t10;
    $[29] = t5;
    $[30] = t6;
    $[31] = t12;
  } else {
    t12 = $[31];
  }
  let t13;
  if ($[32] !== t12 || $[33] !== t4) {
    t13 = <>{t4}{t12}</>;
    $[32] = t12;
    $[33] = t4;
    $[34] = t13;
  } else {
    t13 = $[34];
  }
  return t13;
}
export default ChooseTestVariantModal;